import React, {useCallback, useEffect, useRef, useState} from 'react'
import Button from "../../../UI/Button";
import ModalWindow from "../../../UI/ModalWindow";
import './faqs.scss';


const BrandsFaqModal = ({handleFaqFormSubmit, faqForm, showFaqModal, setShowFaqModal, editingFaq, question, answer, replyId}) => {
    const questionRef = useRef(null);
    const answerRef = useRef(null);

    useEffect(() => {
        const refs = [questionRef, answerRef];
        const handlers = [];
        refs.forEach(ref => {
            if (ref.current) {
                const textarea = ref.current;
                textarea.style.height = "auto";
                textarea.style.height = textarea.scrollHeight + "px";
                textarea.style.overflowY = "hidden";
                const handleInput = function() {
                    this.style.height = "auto";
                    this.style.height = this.scrollHeight + "px";
                };
                textarea.addEventListener("input", handleInput);
                handlers.push({textarea, handleInput});
            }
        });
        // Cleanup
        return () => {
            handlers.forEach(({textarea, handleInput}) => {
                textarea.removeEventListener("input", handleInput);
            });
        };
    }, [showFaqModal, question, answer]);

    return (
        <>
            {showFaqModal && (
                <ModalWindow
                    header={editingFaq ? "Edit FAQ" : "Add FAQ to knowledge"}
                    closeHandler={() => setShowFaqModal(false)}
                    hideClose={true}
                    toTop={true}
                >
                    <form onSubmit={handleFaqFormSubmit} ref={faqForm}>
                        <div className="form-group mb-3">
                            <label>Question</label>
                            <textarea
                                className="form-control faq-textarea"
                                name="reply_faq[question]"
                                ref={questionRef}
                                defaultValue={question}
                                required
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Answer</label>
                            <textarea
                                className="form-control faq-textarea"
                                name="reply_faq[answer]"
                                ref={answerRef}
                                defaultValue={answer}
                                required
                            />
                        </div>
                        <input type="hidden" name="reply_faq[comment_reply_id]" value={replyId}/>
                        <div className="d-flex justify-content-end mt-4">
                            <Button className="btn btn-secondary mx-2" type="button" clickHandler={() => setShowFaqModal(false)}>
                                Cancel
                            </Button>
                            <Button className="btn btn-primary" type="submit">
                                Save
                            </Button>
                        </div>
                    </form>
                </ModalWindow>
            )}
        </>
    )
}

export default React.memo(BrandsFaqModal)